import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { CustomStyles } from './CustomStyles';

const customStylesAddon = AddonBlueprint.make({
  name: 'custom-styles',
  params: {
    name: 'CustomStyles',
    location: 'Content',
    component: CustomStyles,
  },
});

export const techdocsModuleCustomStyles = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [customStylesAddon],
});
